module.exports = __webpack_public_path__ + "img/welfare2.58ab2d6d.png";